import { JoinBarConfigurationMessage } from "./types";

export const defaultJoinBarConfiguration: JoinBarConfigurationMessage = {
  title: "Want to wager?",
  message: "Log in or join to get started.",
  loginCTAText: "Log in",
  signupCTAText: "Join now"
};
